export default "__VITE_ASSET__Cy12rhvY__"